
import metaTiles from '../ServerSide/metaTitles.json'
import seoTexts from '../constants/seoTexts'

/**
 * Get the proper title to set in the head->title tag
 * CAVEATS - This is only for UX purpose. The logic to set the title from
 * the servder is in the src/server.js file.
 * @param {string} urlLocation
 */
export const updateMetaTitle = (urlLocation, operation_types, operation_type, originPath) => {

  let sectionTitle = (urlLocation.pathname === '/') ? 'LJ Ramos Brokers Inmobiliarios ' : urlLocation.pathname.substring(1)
  try {
    if (
      (urlLocation.pathname !== '/' && urlLocation.pathname.split('/').length !== 3) ||
      urlLocation.pathname.includes('sucursal')
    ) {
      if (sectionTitle && sectionTitle.length) {
        if (sectionTitle.indexOf('/') > -1) {
          sectionTitle = sectionTitle.replace('/', ' ')
        }
        sectionTitle =  sectionTitle.replace(/\w\S*/g, (txt) => {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
      }
      if (sectionTitle === 'Propiedades') {
        const operation_type_name = operation_type
          && operation_type.length
          && operation_type[0].name ?
          operation_type[0].name :
          operation_type
          && operation_type.length ?
            operation_types.find((op) => op.id === operation_type[0].id).name : ''
        // eslint-disable-next-line no-prototype-builtins
        const property_type_plural = seoTexts.plurals.hasOwnProperty(originPath.name) ?
          seoTexts.plurals[originPath.name] : 'Propiedades'
        sectionTitle = `Consulta nuestra oferta ${operation_type_name ? `de ${operation_type_name}` : ''} de ${property_type_plural} en LJ Ramos`
      } else {
        // eslint-disable-next-line no-prototype-builtins
        sectionTitle = metaTiles.hasOwnProperty(sectionTitle) ?
          metaTiles[sectionTitle] + ' | LJ Ramos' : 'LJ Ramos'
      }
    } else if (urlLocation.pathname.includes('propiedades') && urlLocation.pathname.split('/').length === 3) {
      const pretyUrl = urlLocation.pathname.split('/')[2]
        .split('-')
        .map((w) =>  w.substring(0,1).toUpperCase()+ w.substring(1))
        .join(' ')
      sectionTitle = pretyUrl  + ' | LJ Ramos'
    }

    const title = document.getElementsByTagName('title')[0]
    title.innerText = sectionTitle
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('The title couldn\'t be updaed', error)
  }

}



// WEBPACK FOOTER //
// ./src/utils/seoUtilities.js